export default {
  presetSelectPlaceholder: 'Voreinstellung auswählen',
  modalTitle: 'Muster-Voreinstellungen',
  currentSelection: 'Aktuelle Auswahl',
};
